import styled from 'styled-components';

import { colors } from 'Constants';

import Card from './index';

export default styled(Card).attrs(props => ({
  padding: '32px'
}))`
  background-color: ${props => props.background || colors.accentLighter};
`;
